export const defaultOption = { value: '', label: 'Välj' };

export const TABLE_LIMIT = 50;
